import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
export default class Footer extends Component {
  view() {
    const t = key => app.translator.trans('bizkaitarra-header.forum.footer.' + key);
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.remove('preset-athletic', 'preset-real-sociedad');
      document.body.classList.add("preset-".concat(clubSlug));
    }
    return m("div", {
      className: "App-footer"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "Footer-content"
    }, m("div", {
      className: "Footer-section Footer-section--links"
    }, m("div", {
      className: "Footer-column"
    }, m("h4", null, app.translator.trans('bizkaitarra-header.forum.footer.community_title')), m("ul", {
      className: "Footer-links"
    }, m("li", null, m("a", {
      href: "/calendario/".concat(app.forum.attribute('nagusiMatchRatingsLatestSeason') || '2025-2026', "/").concat(app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad' ? 'real-sociedad' : 'athletic-club')
    }, t('calendar_link'))), m("li", null, m("a", {
      href: "/clasificacion/".concat(app.forum.attribute('nagusiMatchRatingsLatestSeason') || '2025-2026', "/").concat(app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad' ? 'real-sociedad' : 'athletic-club')
    }, "Clasificaci\xF3n")), m("li", null, m("a", {
      href: "/jugadores"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.nav_title'))), m("li", null, m("a", {
      href: "/aurrera-jokoak"
    }, t('games_link'))), m("li", null, m("a", {
      href: "/estadisticas-uso-foro-".concat(app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic')
    }, t('stats_link'))), app.forum.attribute('nagusiMatchRatingsClubSlug') !== 'real-sociedad' && m("li", null, m("a", {
      href: "/p/vascos-por-el-mundo"
    }, t('vascos_link'))))), m("div", {
      className: "Footer-column"
    }, m("h4", null, app.translator.trans('bizkaitarra-header.forum.footer.info_title')), m("ul", {
      className: "Footer-links"
    }, m("li", null, m("a", {
      href: "/p/quienes-somos"
    }, t('about_link'))), m("li", null, m("a", {
      href: "/p/normas-del-foro"
    }, t('rules_link'))), m("li", null, m("a", {
      href: "/p/privacidad-y-cookies"
    }, t('privacy_link')))))), m("div", {
      className: "Footer-section Footer-section--copyright"
    }, m("div", {
      className: "Footer-logo"
    }, m("img", {
      src: app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad' ? '/assets/brand/reala_logo.webp' : '/assets/brand/aurrera_athletic_logo_cabecera.webp',
      alt: app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad' ? 'Txuriurdin Aurrera' : app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Aurrera Athletic'
    }), m("span", null, app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad' ? 'Txuriurdin Aurrera' : app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Aurrera Athletic')), m("div", {
      className: "Footer-copyright"
    }, "\xA9 ", new Date().getFullYear(), " ", app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad' ? 'Txuriurdin Aurrera' : app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Aurrera Athletic', ". ", app.translator.trans('bizkaitarra-header.forum.footer.all_rights_reserved'))))));
  }
}